import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { modelOf } from '../../../prop-types';
import Product from '../../../models/Product';

@observer
export class ProductImpressions extends Component {
  componentDidMount() {
    this.sendImpressions();
  }

  sendImpressions = () => {
    const { sendProductImpressions, listName, products } = this.props;
    const productList = products.map((product, index) => ({
      product,
      position: index + 1
    }));
    sendProductImpressions(listName, productList);
  };

  render() {
    return null;
  }
}

ProductImpressions.propTypes = {
  products: PropTypes.arrayOf(modelOf(Product)),
  listName: PropTypes.string.isRequired,
  sendProductImpressions: PropTypes.func.isRequired
};

export default inject((stores) => ({
  sendProductImpressions: (...args) =>
    stores.analytics.productImpressions(...args)
}))(ProductImpressions);



// WEBPACK FOOTER //
// ./src/components/product/ProductImpressions/index.jsx